module.exports = {"title":"Softwares","subtitle":"Start training on PC or mobile. Try out our new training methods, including our novel pattern based approach","button":"Create an account"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/softwares/en/jumbotron.yml
// module id = 982
// module chunks = 14633198248673